import { render, staticRenderFns } from "./system.vue?vue&type=template&id=425b8868&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b8868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425b8868')) {
      api.createRecord('425b8868', component.options)
    } else {
      api.reload('425b8868', component.options)
    }
    module.hot.accept("./system.vue?vue&type=template&id=425b8868&scoped=true", function () {
      api.rerender('425b8868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/system.vue"
export default component.exports